"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_router_dom_1 = require("react-router-dom");
const styled_components_1 = __importDefault(require("styled-components"));
const theme_1 = require("../../../theme");
const NavigationContext_1 = require("../../../contexts/NavigationContext");
const isNullish_1 = require("../../../util/isNullish");
const YearContext_1 = require("../../../contexts/YearContext");
const common_styled_components_1 = require("../../common-styled-components");
const isProduction = process.env.NODE_ENV === "production";
const adminTools = [
    {
        path: "/compliance/admin/pools",
        name: "Pools",
    },
    {
        path: "/compliance/admin/ships",
        name: "Ships",
    },
    {
        path: "/compliance/admin/transactions",
        name: "Transactions",
    },
    {
        path: "/compliance/admin/companies",
        name: "Companies",
    },
    {
        path: "/compliance/admin/fleets",
        name: "Fleets",
    },
    {
        path: "/compliance/admin/users",
        name: "Users",
    },
    {
        path: "/compliance/admin/documents",
        name: "Documents",
    },
    {
        path: "/compliance/admin/ports",
        name: "Ports",
    },
    {
        path: "/compliance/admin/integration-tools",
        name: "Integration",
    },
    {
        path: "/compliance/admin/test-data-tools",
        name: "Test data",
    },
].filter((tool) => !isProduction || tool.name !== "Test data");
const AdminToolsContainer = styled_components_1.default.div `
  width: 100%;
  padding: ${theme_1.theme.spacing(5)};
  box-sizing: border-box;

  @media (max-width: ${theme_1.breakpoints.mobilePlus}px) {
    padding: ${theme_1.theme.spacing(3)};
  }
`;
exports.default = () => {
    const { pathname } = (0, react_router_dom_1.useLocation)();
    const selectedTool = adminTools.find((tool) => tool.path === pathname)?.name;
    const { upPath } = (0, NavigationContext_1.useNavigation)();
    const { years, selectedYear } = (0, YearContext_1.useYear)();
    return ((0, jsx_runtime_1.jsxs)(AdminToolsContainer, { children: [(0, jsx_runtime_1.jsx)(common_styled_components_1.Navigation, { children: years.map((year) => ((0, jsx_runtime_1.jsx)(common_styled_components_1.NavigationLink, { to: `${pathname}`, paramUpdates: { year: year.toString() }, "$selected": year === selectedYear, children: year }, year))) }), (0, jsx_runtime_1.jsx)(common_styled_components_1.Navigation, { children: adminTools.map((tool) => ((0, jsx_runtime_1.jsx)(common_styled_components_1.NavigationLink, { to: tool.path, "$selected": tool.name === selectedTool, children: tool.name }, tool.name))) }), !(0, isNullish_1.isNullish)(upPath) && ((0, jsx_runtime_1.jsx)(NavigationContext_1.UpLinkWithHistory, { to: upPath, children: "Back" })), (0, jsx_runtime_1.jsx)(react_router_dom_1.Outlet, {})] }));
};
